module.exports = __webpack_public_path__ + "static/media/arrow-circle-full-yellow.ca956ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-full-yellow.svg
// module id = 71
// module chunks = 0